<template>
  <div class="main">
    <div class="communicate1">
      <div :class="{ active: active == item.companyStationClassId, common: active != item.companyStationClassId }"
        v-for="(item, index) in chooseTypes" :key="index" @click="switchGas(item.companyStationClassId)">
        {{ item.className }}
      </div>
    </div>
    <div class="content">
      <div v-for="(item, index) in stationList" :key="index" class="contentItem">
        <div class="contentItem1">
          <div class="contentItemImg">
            <img :src="item.stationImage" alt="">
          </div>
          <div class="contentItem2">
            <div class="contentItem3">
              <div class="ellipsis" style="width: 300px;">{{ item.stationTitle }}</div>
              <div>{{ item.className }}</div>
            </div>
            <div>{{ item.stationContent }}</div>
          </div>
        </div>
        <div class="apply" v-if="item.isApply == 0" @click="goApply(item.companyStationId)">立即报名</div>
        <div class="notApply" v-if="item.isApply == 1" @click="goApply(item.companyStationId, 'cancel')">已报名</div>
      </div>
    </div>
    <div class="footer">
      <div>共{{ total }}个服务</div>
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageNum"
        layout="prev, pager, next, jumper" :page-size="10" :total="total">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="show1" title="报名信息">
      <el-form :model="form1" class="form1" ref="form1" :rules="rules" label-width="70px">
        <el-form-item label="真实姓名" prop="companyUserName" :rules="[ 
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
      { pattern: /^[\u4e00-\u9fff]+$/, message: '请填写正确的真实姓名', trigger: 'blur'
 	  }
    ]">
          <el-input v-model="form1.companyUserName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="companyUserPhone">
          <el-input v-model="form1.companyUserPhone" placeholder="请输入" maxlength="11"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      chooseTypes: [],
      active: '0',
      stationList: [],
      pageNum: 1,
      total: 0,
      show1: false,
      form1: {
        companyStationId: '',
        companyUserName: '',
        companyUserPhone: ''
      },
      rules: {
        companyUserName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
        ],
        companyUserPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this.getCompanyStationClassList()
    this.getCompanyStationList()
  },
  methods: {
    submit() {
      let that = this
      that.$refs.form1.validate(valid => {
        if (valid) {
          that.$post('/api/company/platform/companyStationApply', { ...that.form1 }).then(res => {
            that.$message({
              message: '已报名',
              type: 'success'
            })
            that.$refs.form1.resetFields();
            that.show1 = false
            this.getCompanyStationList()
          })
        }
      })
    },
    goApply(id, type) {
      if (type == 'cancel') {
        this.$post('/api/company/platform/companyStationApply', { companyStationId:id}).then(res => {
          this.$message({
            message: '已取消报名',
            type: 'success'
          })
          this.getCompanyStationList()
        })
        return
      }
      this.form1.companyStationId = id
      this.show1 = true
    },
    getCompanyStationClassList() {
      this.$get('/api/company/platform/getCompanyStationClassList', {}).then(res => {
        this.chooseTypes = res.data,
          this.active = res.data[0].companyStationClassId
      })
    },
    switchGas(id) {
      this.active = id
      this.getCompanyStationList()

    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum
      this.getCompanyStationList()
    },
    getCompanyStationList() {
      this.$get('/api/company/platform/getCompanyStationList', {
        companyStationClassId: this.active == '0' ? '' : this.active,
        pageNum: this.pageNum,
        pageSize: 10,
      }).then(res => {
        this.stationList = res.data.list,
          this.total = res.data.total
      })
    },
  }
}
</script>
<style scoped>
.main {
  padding: 30px;
}

::v-deep .el-dialog {
  width: 500px;
}

.form1 {
  width: 400px;
}

.communicate1 {
  display: flex;
  margin-top: 30px;
}

.communicate1>div {
  padding: 8px 0;
  width: 100px;
  height: 22px;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
}

.common {
  color: #555555;
}

.active {
  background-color: #0051aa;
  color: #ffffff;
}

.content {
  margin-bottom: 50px;
}

.contentItem {
  padding: 20px;
  background: linear-gradient(179deg, rgba(255, 255, 255, 0.15) 0%, #FFFFFF 100%);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}

.contentItem1 {
  display: flex;
}

.contentItemImg {
  width: 512px;
  height: 182px;
  border-radius: 6px 6px 6px 6px;
  ;
}

.contentItemImg>img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.contentItem2 {
  /* display: flex; */
  margin-left: 20px;
}

.contentItem2>div:nth-of-type(2) {
  width: 500px;
  font-weight: normal;
  font-size: 16px;
  color: #555555;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  word-break: break-all
}

.contentItem3 {
  display: flex;
  align-items: center;
}

.contentItem3>div:nth-of-type(1) {
  height: 25px;
  font-weight: bold;
  font-size: 18px;
  color: #555555;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.contentItem3>div:nth-of-type(2) {
  margin-left: 20px;
  /* height: 25px; */
  font-weight: normal;
  font-size: 16px;
  color: #0051AA;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.apply {
  padding: 0 10px;
  /* width: 122px; */
  height: 42px;
  background: #0051AA;
  border-radius: 2px;
  font-weight: normal;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 42px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-right: 20px;
  cursor: pointer;
}

.notApply {
  padding: 0 10px;
  /* width: 122px; */
  height: 42px;
  background: #e7e7e7;
  border-radius: 2px;
  font-weight: normal;
  font-size: 16px;
  color: #777777;
  line-height: 42px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-right: 20px;
  cursor: pointer;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
